type Props = {};

const PageUnAuth = (props: Props) => {
  return <div>PageUnAuth</div>;
};

export default PageUnAuth;
